import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import MercosulPlate from 'shared/mercosul-plate/mercosul-license-plate'

interface TextInputSelectorProps {
  label: string
  icon: string
  value: string
  placeholder?: string
  maxLength?: number
  showPlatePreview?: boolean
  onChange: (value: string) => void
  onAdd: () => void
}

export const TextInputSelector: React.FC<TextInputSelectorProps> = ({
  label,
  icon,
  value,
  placeholder,
  maxLength,
  showPlatePreview = false,
  onChange,
  onAdd,
}) => {
  return (
    <div className='alarms-field'>
      <label htmlFor='value' className='alarms-label'>
        <i className={icon} />
        {label}
      </label>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'start',
        }}
      >
        <div style={{ flex: 1 }}>
          <InputText
            id='value'
            value={value}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onAdd()
              }
            }}
            placeholder={placeholder}
            className='alarms-input alarms-plate-input'
            maxLength={maxLength}
            style={{ width: '100%' }}
          />
          {showPlatePreview && value && (
            <div className='flex mt-2'>
              <MercosulPlate licensePlate={value} size='M' />
            </div>
          )}
        </div>
        <Button
          icon='pi pi-plus'
          label='Adicionar'
          onClick={onAdd}
          style={{ marginTop: '0' }}
        />
      </div>
    </div>
  )
}
